import { motion } from 'framer-motion';
import { Star, Quote, BadgeCheck } from 'lucide-react';

const REVIEWS = [
  {
    id: 'marianne',
    quote: "They found dust I didn't know existed. My recurring clean is the highlight of my week — same team, same sparkle, every time.",
    name: 'Marianne L.',
    role: 'Homeowner · Surrey',
    featured: true,
  },
  {
    id: 'david',
    quote: 'Our office passed a surprise client walkthrough two hours after their night crew finished. Flawless.',
    name: 'David O.',
    role: 'Office Manager · Vancouver',
    featured: false,
  },
  {
    id: 'priya',
    quote: 'Post-renovation cleanup took three days with our old vendor. GMP did it in one — and the windows actually squeak.',
    name: 'Priya S.',
    role: 'Restaurant Owner · Burnaby',
    featured: false,
  },
];

function Stars() {
  return (
    <div className="flex gap-1">
      {[...Array(5)].map((_, i) => (
        <Star key={i} size={15} className="text-amber-400" fill="currentColor" strokeWidth={0} />
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section id="reviews" data-testid="testimonials-section" className="bg-ceramic py-24 lg:py-36 border-t border-stone-200/70">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-mint mb-5">03 — Reviews</p>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-obsidian leading-[1.05]">
            Loved by homes
            <br />
            and businesses.
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <motion.figure
              key={r.id}
              data-testid={`testimonial-card-${r.id}`}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className={`relative rounded-3xl p-8 lg:p-9 flex flex-col h-full transition-transform duration-500 hover:-translate-y-1.5 ${
                r.featured
                  ? 'bg-obsidian grain text-white'
                  : 'bg-white border border-stone-200/80'
              }`}
            >
              <Quote size={28} className={r.featured ? 'text-mint-vibrant' : 'text-mint/30'} fill="currentColor" strokeWidth={0} />
              <blockquote className={`mt-5 flex-1 leading-relaxed ${r.featured ? 'text-lg lg:text-xl text-stone-100 font-medium' : 'text-base text-stone-600'}`}>
                "{r.quote}"
              </blockquote>
              <figcaption className="mt-7 pt-6 border-t border-dashed border-stone-200/40 flex items-center justify-between">
                <div>
                  <p className={`font-semibold ${r.featured ? 'text-white' : 'text-obsidian'}`}>{r.name}</p>
                  <p className={`text-xs mt-0.5 ${r.featured ? 'text-stone-400' : 'text-stone-500'}`}>{r.role}</p>
                </div>
                <div className="flex flex-col items-end gap-1.5">
                  <Stars />
                  <span className="flex items-center gap-1 text-[10px] font-mono uppercase tracking-wider text-mint">
                    <BadgeCheck size={11} /> Verified
                  </span>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
